import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config || {};
    const isAuthCall = (original.url || "").includes("/auth/");
    if (err?.response?.status === 401 && !original._retried && !isAuthCall) {
      original._retried = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return api(original);
      } catch {
        // refresh falhou — sessão realmente expirada; o AppShell redireciona ao login
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e && e.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (d) return String(d);
  return err?.message || "Erro inesperado";
}

export function fmtGB(gb) {
  const n = Number(gb) || 0;
  if (Math.abs(n) >= 1000) return `${(n / 1000).toFixed(2)} TB`;
  return `${n.toFixed(2)} GB`;
}

export function fmtBytes(bytes) {
  const n = Number(bytes) || 0;
  if (n >= 1e9) return `${(n / 1e9).toFixed(2)} GB`;
  if (n >= 1e6) return `${(n / 1e6).toFixed(1)} MB`;
  return `${(n / 1e3).toFixed(0)} KB`;
}

export function fmtBRL(v) {
  return Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export function fmtEUR(v) {
  return Number(v || 0).toLocaleString("pt-PT", { style: "currency", currency: "EUR" });
}

// histórico misto: registros antigos em BRL (amount_brl), novos em EUR (amount_eur)
export function fmtPay(obj) {
  if (obj?.amount_eur != null) return fmtEUR(obj.amount_eur);
  if (obj?.amount_brl != null) return fmtBRL(obj.amount_brl);
  if (obj?.amount != null) return fmtEUR(obj.amount);
  return "—";
}
